module.exports = __webpack_public_path__ + "static/media/adobe.741ce910.png";